export const diseases_oms_eng = [
  {
    label: 'Overweight',
    label_show: 'Obesity',
    page: 13,
    Xpos_image: '156px',
    Ypos_image: '480px',
    Xlabel: '175px',
    Ylabel: '565px',
    width: '79px',
    height: 'auto',
    result_comp: [
      { min: 1, max: 3, image: 'overweight_0' },
      { min: 4, max: 6, image: 'overweight_1' },
      { min: 7, max: 10, image: 'overweight_2' }
    ]
  },
  {
    label: 'Metabolic syndrome',
    label_show: 'Dyslipidemia',
    page: 13,
    Xpos_image: '292px',
    Ypos_image: '480px',
    Xlabel: '295px',
    Ylabel: '565px',
    width: '79px',
    height: 'auto',
    result_comp: [
      { min: 1, max: 3, image: 'metabolicsyndrome_0' },
      { min: 4, max: 6, image: 'metabolicsyndrome_1' },
      { min: 7, max: 10, image: 'metabolicsyndrome_2' }
    ]
  },
  {
    label: 'Visceral',
    label_show: ['Visceral fat', 'Accumulation'],
    page: 13,
    Xpos_image: '426px',
    Ypos_image: '480px',
    Xlabel: '428px',
    Ylabel: '565px',
    width: '79px',
    height: 'auto',
    result_comp: [
      { min: 1, max: 3, image: 'accumulation_0' },
      { min: 4, max: 6, image: 'accumulation_1' },
      { min: 7, max: 10, image: 'accumulation_2' }
    ]
  },
  {
    label: 'Insulin',
    label_show: 'Insulin Resistance',
    page: 13,
    Xpos_image: '555px',
    Ypos_image: '480px',
    Xlabel: '545px',
    Ylabel: '565px',
    width: '79px',
    height: 'auto',
    result_comp: [
      { min: 1, max: 3, image: 'insulin_0' },
      { min: 4, max: 6, image: 'insulin_1' },
      { min: 7, max: 10, image: 'insulin_2' }
    ]
  },
  {
    label: 'Type 2 diabetes',
    label_show: ['Type 2', 'Diabetes'],
    page: 13,
    Xpos_image: '225px',
    Ypos_image: '620px',
    Xlabel: '240px',
    Ylabel: '705px',
    width: '79px',
    height: 'auto',
    result_comp: [
      { min: 1, max: 3, image: 'type2diabetes_0' },
      { min: 4, max: 6, image: 'type2diabetes_1' },
      { min: 7, max: 10, image: 'type2diabetes_2' }
    ]
  },
  {
    label: 'Fatty liver',
    label_show: 'Fatty Liver',
    page: 13,
    Xpos_image: '360px',
    Ypos_image: '620px',
    Xlabel: '372px',
    Ylabel: '705px',
    width: '79px',
    height: 'auto',
    result_comp: [
      { min: 1, max: 3, image: 'fattyliver_0' },
      { min: 4, max: 6, image: 'fattyliver_1' },
      { min: 7, max: 10, image: 'fattyliver_2' }
    ]
  },
  {
    label: 'Excessive lipopolysaccharide',
    label_show: ['Excessive', 'Lipopolysaccharide'],
    page: 13,
    Xpos_image: '500px',
    Ypos_image: '620px',
    Xlabel: '486px',
    Ylabel: '705px',
    width: '79px',
    height: 'auto',
    result_comp: [
      { min: 1, max: 3, image: 'excessivelipopolysaccharide_0' },
      { min: 4, max: 6, image: 'excessivelipopolysaccharide_1' },
      { min: 7, max: 10, image: 'excessivelipopolysaccharide_2' }
    ]
  },
]

export const diseases_oms_thai = [
  {
    label: 'Overweight',
    label_show: 'น้ำหนักเกิน',
    page: 12,
    Xpos_image: '156px',
    Ypos_image: '480px',
    Xlabel: '165px',
    Ylabel: '565px',
    width: '79px',
    height: 'auto',
    result_comp: [
      { min: 1, max: 3, image: 'overweight_0' },
      { min: 4, max: 6, image: 'overweight_1' },
      { min: 7, max: 10, image: 'overweight_2' }
    ]
  },
  {
    label: 'Metabolic syndrome',
    label_show: ['ไขมันในเลือด','ผิดปกติ'],
    page: 12,
    Xpos_image: '292px',
    Ypos_image: '480px',
    Xlabel: '300px',
    Ylabel: '565px',
    width: '79px',
    height: 'auto',
    result_comp: [
      { min: 1, max: 3, image: 'metabolicsyndrome_0' },
      { min: 4, max: 6, image: 'metabolicsyndrome_1' },
      { min: 7, max: 10, image: 'metabolicsyndrome_2' }
    ]
  },
  {
    label: 'Visceral',
    label_show: 'ไขมันสะสมในช่องท้อง',
    page: 12,
    Xpos_image: '426px',
    Ypos_image: '480px',
    Xlabel: '416px',
    Ylabel: '565px',
    width: '79px',
    height: 'auto',
    result_comp: [
      { min: 1, max: 3, image: 'accumulation_0' },
      { min: 4, max: 6, image: 'accumulation_1' },
      { min: 7, max: 10, image: 'accumulation_2' }
    ]
  },
  {
    label: 'Insulin',
    label_show: 'ดื้ออินซูลิน',
    page: 12,
    Xpos_image: '555px',
    Ypos_image: '480px',
    Xlabel: '568px',
    Ylabel: '565px',
    width: '79px',
    height: 'auto',
    result_comp: [
      { min: 1, max: 3, image: 'insulin_0' },
      { min: 4, max: 6, image: 'insulin_1' },
      { min: 7, max: 10, image: 'insulin_2' }
    ]
  },
  {
    label: 'Type 2 diabetes',
    label_show:'เบาหวาน ประเภท 2',
    page: 12,
    Xpos_image: '225px',
    Ypos_image: '620px',
    Xlabel: '220px',
    Ylabel: '705px',
    width: '79px',
    height: 'auto',
    result_comp: [
      { min: 1, max: 3, image: 'type2diabetes_0' },
      { min: 4, max: 6, image: 'type2diabetes_1' },
      { min: 7, max: 10, image: 'type2diabetes_2' }
    ]
  },
  {
    label: 'Fatty liver',
    label_show: 'ไขมันพอกตับ',
    page: 12,
    Xpos_image: '360px',
    Ypos_image: '620px',
    Xlabel: '366px',
    Ylabel: '705px',
    width: '79px',
    height: 'auto',
    result_comp: [
      { min: 1, max: 3, image: 'fattyliver_0' },
      { min: 4, max: 6, image: 'fattyliver_1' },
      { min: 7, max: 10, image: 'fattyliver_2' }
    ]
  },
  {
    label: 'Excessive lipopolysaccharide',
    label_show: 'สาร Lipopolysaccharide สูง',
    page: 12,
    Xpos_image: '500px',
    Ypos_image: '620px',
    Xlabel: '470px',
    Ylabel: '705px',
    width: '79px',
    height: 'auto',
    result_comp: [
      { min: 1, max: 3, image: 'excessivelipopolysaccharide_0' },
      { min: 4, max: 6, image: 'excessivelipopolysaccharide_1' },
      { min: 7, max: 10, image: 'excessivelipopolysaccharide_2' }
    ]
  },
]

export const diseases_image_oms_eng = [
  // {
  //   label: 'Eczema',
  //   label_show: 'Eczema',
  //   page: 12,
  //   Xpos_image: '77px',
  //   Ypos_image: '685px',
  //   Xlabel: '90px',
  //   Ylabel: '757px',
  //   width: '70px',
  //   height: 'auto'
  // },
];

export const diseases_image_oms_thai = [
  // {
  //   label: 'Eczema',
  //   label_show: 'Eczema',
  //   page: 12,
  //   Xpos_image: '77px',
  //   Ypos_image: '685px',
  //   Xlabel: '90px',
  //   Ylabel: '757px',
  //   width: '70px',
  //   height: 'auto'
  // },
];